export default "__VITE_ASSET__D5$Y2I6F__"